import brandDomains from 'src/config/hostConfig';

const NO_MATCH = 999;

const normalizeHost = (host: string = '') => {
	const value = `${host || ''}`.trim().toLowerCase();
	return value.replace(/^https?:\/\//, '').split('/')[0].replace(/:\d+$/, '');
};

const removeWww = (host: string = '') => host.replace(/^www\./, '');

const getHostMatchRank = (host: string, domain: string) => {
	const normalizedHost = normalizeHost(host);
	const normalizedDomain = normalizeHost(domain);
	const hostWithoutWww = removeWww(normalizedHost);
	const domainWithoutWww = removeWww(normalizedDomain);

	if (!normalizedHost || !normalizedDomain) return NO_MATCH;

	if (normalizedHost === normalizedDomain) return 0;
	if (hostWithoutWww === domainWithoutWww) return 1;
	if (normalizedHost.endsWith(`.${domainWithoutWww}`)) return 2;

	return NO_MATCH;
};

export const getBrandByHost = (host: string = '') => {
	const currentHost = host || (typeof window !== 'undefined' ? window.location.host : '');
	return brandDomains.reduce((bestMatch, brandDomain) => {
		const rank = getHostMatchRank(currentHost, brandDomain.domain);

		if (rank < bestMatch.rank) {
			return { brandDomain, rank };
		}

		return bestMatch;
	}, { brandDomain: undefined, rank: NO_MATCH }).brandDomain;
};
